import CustomFileInputSecondary from "@/components/Form/InputFields/CustomFileInputSecondary";
import SpacingGrid from "@/components/Grid/SpacingGrid";
import { useWatch } from "react-hook-form";
import { ListTypeModuleCommonProps } from "../../beeswaxList.interface";

export default function Domain({
  errors,
  control,
  isEdit,
  id,
  onUploadListItem,
  isUploadingListItem,
  subText,
  isActive,
  inActiveText,
}: ListTypeModuleCommonProps) {
  const file = useWatch({ control, name: "domain" });

  function onUploadFile() {
    onUploadListItem(file, id);
  }
  return (
    <SpacingGrid itemContainer spacingType="form">
      <SpacingGrid item>
        <CustomFileInputSecondary
          control={control}
          name="domain"
          handleUpload={onUploadFile}
          label="Upload File"
          disabled={isUploadingListItem || !isActive}
          disableUpload={!file || !isActive}
          subText={subText}
          inputProps={{
            accept: ".csv, .txt",
          }}
          disabledTooltip={!isActive ? inActiveText : undefined}
        />
      </SpacingGrid>
    </SpacingGrid>
  );
}
